import {DeviceSize, useDeviceSize} from '../theme/helpers';
import {useMemo} from 'react';

export const useIsMobile = () => {
  const deviceSize = useDeviceSize();
  return useMemo(() => deviceSize === DeviceSize.mobile, [deviceSize]);
};
